import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Elana Gabrielle — New-customers campaign (adc_zk3kgrvzah). Real lifetime
// aggregates from ANALYTICS.ADS_SNAPSHOTS.MANAGER_METRICS_CAMPAIGN_PERIODS.
// Lifetime aggregates over the 31 complete months Mar 2024 – Aug 2026; monthly
// series lives in realBrandData.ts.
//
// `monthlyBudgetDollars` is the shared pool, not a cap on this campaign. The
// advertiser is POOLED, so AD_CAMPAIGNS reports no per-campaign budget and both
// campaigns draw on the same $400 — which is why the reorder campaign carries the
// same figure rather than a slice of it. Nothing sums the two.
//
// `salesDollars` is booked sales and `bestEstimateSalesDollars` the first-year
// projection, which sits slightly below it now that the early cohorts have run
// past their first twelve months.
export const campEgNew: FaireAdCampaignEntity = {
  token: "camp_eg_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_elana_gabrielle",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 400,
  startedRunningAt: "2024-03-07",
  segmentMetrics: {
    numCustomersAcquired: 51,
    salesDollars: 24438,
    totalAdsSpendDollars: 4353,
    cpaDollars: 85,
    bestEstimateSalesDollars: 21881,
    bestEstimateRoas: 5.03,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-19T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
